<li class="m-steppers-item"
    :class="{ 'm--is-visited' : isVisited,
              'm--is-in-progress' : isInProgress,
              'm--is-disabled' : isDisabled,
              'm--is-completed': completed,
              'm--is-link': isLink }">
    <component class="m-steppers-item__button"
               :is="componentToShow"
               :to="propUrl"
               :tabindex="isTabIndex"
               :role="role"
               :aria-selected="isInProgress"
               @keyup.enter="onClick"
               @click="onClick">
        <div class="m-steppers-item__icon">
            <m-icon :name="iconName"
                    :svg-title="iconTitle"></m-icon>
            <m-icon class="m-steppers-item__icon-completed"
                    v-if="completed"
                    name="m-svg__completed-filled"></m-icon>
        </div>
        <div class="m-steppers-item__title"
             @click="onClick"
             ref="title">
            <slot></slot>
        </div>
    </component>
</li>
